import { yupResolver } from "@hookform/resolvers/yup";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import * as React from "react";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import * as yup from "yup";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import ResetButton from "../../../common/components/Buttons/ResetButton";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import InputField from "../../../common/components/FormFields/InputField";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import DatePickerFieldNew from "../../../common/components/FormFields/DatePickerFieldNew";
import {
  deleteAlert,
  errorAlert,
  successAlert,
} from "../../../common/components/Toasts/CustomToasts";
import { fetchUserActionsByMenuId } from "../../../commonServices/functionalityServices/FunctionalityServices";
import // fetchSearchDropDown,

// getBedTransferPatientInfo,
"../../../commonServices/patientInfoServices/PatientInfoServices";
import IPDBilling from "../../../ipd/components/bill/IPDBilling";
import {
  convertToPackage,
  deleteService,
  getAutoSearchPatientList,
  getDoctorList,
  getPatientData,
  saveAlterIPDCharges,
  saveServices,
  searchService,
} from "../../services/charges/IPDCharges";
import AddedServiceTable from "./AddedServiceTable";
import ConvertToCharge from "./ConvertToCharge";
import ConvertToPackage from "./ConvertToPackage";
import AlterIPDChargesTable from "./AlterIPDChargesTable";
import { format, isAfter } from "date-fns";
import CheckBoxField from "../../../common/components/FormFields/CheckBoxField";
import TimePickerFieldNew from "../../../common/components/FormFields/TimePickerFieldNew";
import { fetchBedCategory } from "../../../commonServices/miscellaneousServices/MiscServices";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import CreateableSelect from "../../../common/components/FormFields/CreateableSelect";
import { getWard } from "../../../nursingStation/services/cliinicalChartServices/painAssesmentService/PainAssesmentService";
import { getBedsByFloor } from "../../../commonServices/bedServices/BedServices";
const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  overflowY: "scroll",
  bgcolor: "background.paper",
  boxShadow: 24,
  width: "90%",
  height: "95%",
  border: "1px solid gray",
};

export default function AlterIPDCharges(props) {
  let unitkey = JSON.parse(localStorage.getItem("userInfo"));

  let location = useLocation();

  //

  const [serviceList, setServiceList] = React.useState();
  // yup Schema validation for form fields
  const schema = yup.object().shape({
    searchServiceList: yup
      .object()
      .nullable()
      .shape({
        value: yup.string(),
        label: yup.string(),
      })
      .required("Please Select Service"),
    qty: yup
      .string()
      .required("Required")
      .matches(/^0*[1-9]\d*$/, "Invalid Value"),

    rate: yup
      .string()
      .required("Required")
      .matches(/^(\d*\.)?\d+$/, "Invalid Value"),

    discountPercent: yup
      .string()
      .nullable()
      .when("searchServiceList", (searchServiceList) => {
        if (searchServiceList !== null) {
          if (searchServiceList.discountApplicable === true) {
            return yup
              .string()
              .nullable()
              .matches(/^100(\.0{1,8})?|\d{1,2}(\.\d{1,8})?$/, "Invalid")
              .required("Required");
          }
        }
      }),
    discountAmount: yup
      .string()
      .nullable()
      .when("searchServiceList", (searchServiceList) => {
        if (searchServiceList !== null) {
          if (
            searchServiceList.discountApplicable !== null &&
            searchServiceList.discountApplicable === true
          ) {
            return yup.string().nullable().required("Required");
          }
        }
      }),
    doctor: yup
      .object()
      .nullable()
      .when("searchServiceList", (searchServiceList) => {
        if (searchServiceList !== null) {
          if (
            searchServiceList.DoctorShare !== null &&
            searchServiceList.DoctorShare === true
          ) {
            return yup
              .object()
              .nullable()
              .shape({
                value: yup.string(),
                label: yup.string(),
              })
              .required("Required");
          }
        }
      }),
  });

  let defaultValues = {
    // fromDate: new Date(),
    // toDate: new Date(),
    searchServiceList: null,
    qty: "",
    rate: "",
    discountPercent: 0,
    discountAmount: 0,
    doctor: null,
    admissionUnderPackage: false,
    serviceDate: new Date(),
    serviceTime: new Date(),
    ward: null,
    bedCategory: null,
    bedNo: null,
  };

  const {
    control,
    handleSubmit,
    reset,
    register,
    formState: { errors },
    setValue,
    watch,
    resetField,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });
  const {
    control: control1,
    handleSubmit: handleSubmit1,
    reset: reset1,
    formState: { errors1 },
    setValue: setValue1,
    watch: watch1,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      appliedDiscountPercent: 0,
      appliedDiscountAmount: 0,
    },
  });
  //
  const [userActions, setUserActions] = useState([]);
  //
  const [patientList, setPatientList] = React.useState([]);
  const [admissionId, setAdmissionId] = React.useState(null);
  const [patientId, setPatientId] = React.useState(null);
  const [bedCategoryId, setbedCategoryId] = React.useState(null);
  const [tariffId, setTariffId] = React.useState(null);
  const [visitId, setVisitId] = React.useState(null);
  const [selectedPatient, setSelectedPatient] = React.useState();
  const [addedServices, setAddedSevices] = React.useState([]);
  const [savedServices, setSavedSevices] = React.useState([]);
  const [dataId, setDataId] = useState(null);
  const [actions, setActions] = React.useState(["Edit", "Delete"]);
  const [isDisable, setIsDisable] = React.useState(false);
  const [previousCharges, setPreviousCharges] = React.useState([]);
  const [style, setStyle] = React.useState("col-span-5");
  const [isDoctorShareApplicable, setIsDoctorShareApplicable] =
    React.useState(null);
  const [doctors, setDoctors] = useState();
  const [isDiscountApplicable, setIsDiscountApplicable] = React.useState(null);
  const [index, setIndex] = React.useState(null);
  const [status, setStatus] = React.useState(null);
  const [rowData, setRowData] = React.useState(null);
  const [openCovertToCharge, setOpenCovertToCharge] = React.useState(false);
  const [category, setCategory] = React.useState("All");
  const [totalPayable, setTotalPayable] = React.useState(0);
  const [remainingAmount, setRemainingAmount] = React.useState(0);
  const [previousChargesAction, setPreviousChargesAction] =
    React.useState(false);
  const [selected, setSelected] = React.useState([]);
  //Confirmation Modal useState
  const [openConfirmation, setOpenConfirmation] = useState(false);
  //From and To Date useState
  const [openFromDate, setOpenFromDate] = useState(false);
  const [openToDate, setOpenToDate] = useState(false);
  const [isByDate, setIsByDate] = useState(false);
  const [openIpdBill, setopenIpdBill] = useState(false);

  //consolidate useState
  // const [isConsolidate, setIsConsolidate]= useState(false)

  //Extra useState value
  const [free, setFree] = useState(0);
  const [isPackage, setIsPackage] = useState(false);
  const [isEmergency, setIsEmergency] = useState(false);
  //useState to Search Previous Charges
  const [previousChargesDropdown, setPreviousChargesDropdown] = React.useState(
    []
  );
  const [previousChargesList, setPreviousChargesList] = React.useState([]);
  const [searchedPreviousCharges, setSearchedPreviousCharges] =
    React.useState(false);

  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [classId, setClassId] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [minFromDate, setMinFromDate] = useState(null);
  const [minToDate, setMinToDate] = useState(null);

  const [groupId, setGroupId] = useState(null);
  const [checkDuplicate, setCheckDuplicate] = useState(false);
  const [ipdChargesWindow, setIpdChargesWindow] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openSaveModal, setOpenSaveModal] = useState(false);
  const [billMenuId, setBillMenuId] = useState(null);
  const [privilege, setPrivilege] = useState("");
  const [checkIsPackage, setCheckIsPackage] = useState(false);
  const [wardOptions, setWardOptions] = useState([]);
  const [bedCategoryOptions, setBedCategoryOptions] = useState([]);
  const [bedNoOptions, setBedNoOptions] = useState([]);
  const [finalAlterData, setFinalAlterData] = useState(null);
  //

  let requiredInfoList = [
    {
      amount: 0,
      bankId: 0,
      paymentDate: "",
      paymentType: {
        id: 4,
        label: "CASH",
        value: "CASH",
      },
    },
  ];

  let fromDateVal = watch("fromDate");

  // Hanmant Changes
  let ipdChargesSearchVal = watch("ipdChargesSearch");

  let admissionIdValue;

  const handlCloseIpdBillAfterFinalSave = () => {
    setAdmissionId(null);
    setPatientId(null);
    setSelectedPatient(null);
  };

  //API for Patient Search
  const handlePatientSearch = (e) => {
    if (e.length > 0) {
      setSearchedPreviousCharges(false);
      getAutoSearchPatientList(e, true)
        .then((response) => {
          setPatientList(response.data.result);
        })
        .catch((response) => {});
    } else {
      setAddedSevices([]);
      setSavedSevices([]);
      setValue("serviceDate", new Date());
      setValue("serviceTime", new Date());
    }
  };

  //API For Get Patient Info and Previous Services
  const handlePatientInfo = () => {
    const listObj = {
      admissionId: admissionId,
      category: category,
      consolidate: false,
      fromDate: null,
      patientId: patientId,
      toDate: null,
      isCancelled: false,
    };

    if (admissionId !== null && searchedPreviousCharges === false) {
      getPatientData(listObj)
        .then((response) => {
          // props.setCompanyId(response.data.result.CompanyId);
          setSelectedPatient(response.data.result);
          setPreviousCharges(response.data.result.list);
          setPreviousChargesList(response.data.result.list);
          setbedCategoryId(response.data.result.BedId);
          setTariffId(response.data.result.TariffId);
          setVisitId(response.data.result?.getPatientDetails?.visitId);
          let totalPay = 0;
          response.data.result.list.forEach((item) => {
            if (item["TotalAmount"] > 0) {
              totalPay += item["TotalAmount"];
            }
          });
          setTotalPayable(totalPay);

          setValue("ward", {
            id: response?.data?.result?.wardId,
            value: response?.data?.result?.wardId,
            label: response?.data?.result?.Ward,
          });
          setValue("bedCategory", {
            id4: response?.data?.result?.bedCategoryId,
            value: response?.data?.result?.bedCategoryId,
            label: response?.data?.result?.BedCategory,
          });
          setValue("bedNo", {
            id: response?.data?.result?.BedId,
            value: response?.data?.result?.BedId,
            label: response?.data?.result?.BedNo,
          });
          getWard(response.data.result?.floorId).then((response) => {
            setWardOptions(response?.data?.result);
          });
          getBedsByFloor(response.data.result?.floorId).then((response) => {
            setBedNoOptions(response?.data?.result);
          });
        })
        .catch((response) => {});
    } else {
      setSelectedPatient(null);
      // setPreviousCharges([]);
    }
  };

  //Handle Min From Date
  const handleMinFromDate = () => {
    if (selectedPatient) {
      let currentDate = String(new Date().getDate()).padStart(2, "0");
      let currentMonth = String(new Date().getMonth() + 1).padStart(2, "0");
      let currentYear = new Date().getFullYear();
      let fullDate =
        currentDate + "-" + currentMonth + "-" + currentYear.toString();

      let minFromDateValue = selectedPatient.admissionDate.split("-");
      if (fullDate == selectedPatient.admissionDate) {
        let currentDateData = new Date();
        setMinFromDate(currentDateData);
      } else {
        setMinFromDate(
          new Date(
            minFromDateValue[2],
            minFromDateValue[1] - 1,
            minFromDateValue[0]
          )
        );
      }
    }
  };

  useEffect(() => {
    handleMinFromDate();
    if (fromDateVal) {
      setMinToDate(fromDateVal);
    }
  }, [selectedPatient]);

  //Calculate total Payable Amount

  useEffect(() => {
    // let totalPay = 0;
    // previousCharges.map((item) => {
    //   totalPay = totalPay + item["TotalAmount"];
    // });
    // setTotalPayable(totalPay);

    let remainingPay = 0;

    previousCharges?.forEach((item) => {
      if (item["TotalAmount"] > 0) {
        remainingPay += item["TotalAmount"];
      }
    });
    setRemainingAmount(Number(remainingPay - totalPayable));

    console.log("totalPayable", totalPayable, "remainingPay", remainingPay);
  }, [previousCharges]);

  useEffect(() => {
    if (
      location.state &&
      location.state !== null &&
      location.state?.admissionId
    ) {
      setAdmissionId(location.state?.admissionId);
      setbedCategoryId(location.state.bedCategory);
      setTariffId(location.state.tariff);
      setPatientId(location.state?.patientId);
    }
    if (
      admissionId &&
      admissionId !== null &&
      searchedPreviousCharges === false
    ) {
      handlePatientInfo();
    }
  }, [admissionId, category]);

  useEffect(() => {
    if (
      props.admissionId &&
      props.admissionId != null &&
      props.patientId &&
      props.patientId != null
    ) {
      setAdmissionId(props?.admissionId);
      setPatientId(props?.patientId);
    }
  }, [previousCharges.length, props]);

  // calculate discount Amount
  let getRate = watch("rate");
  let getDiscountPercent = parseFloat(watch("discountPercent"));
  let getDiscountAmount = parseFloat(watch("discountAmount"));
  let getQuantity = watch("qty");
  let discountAmount, totalAmount;
  let serviceRate = parseFloat(getRate);
  let serviceQuantity = parseInt(getQuantity);
  let serviceDiscountPer = parseFloat(getDiscountPercent);
  let serviceDiscountAmt = parseFloat(getDiscountAmount);

  useEffect(() => {
    // if (getDiscountPercent && typeof getDiscountAmount === "number") {
    if (
      isDiscountApplicable !== null &&
      isDiscountApplicable === true &&
      getDiscountPercent !== 0 &&
      typeof getDiscountPercent === "number" &&
      typeof serviceDiscountPer === "number"
    ) {
      totalAmount = parseFloat(serviceRate * serviceQuantity);
      let priceAfterDiscount =
        totalAmount - (totalAmount * parseFloat(serviceDiscountPer)) / 100;
      discountAmount = parseFloat(totalAmount - priceAfterDiscount).toFixed(1);

      setValue("discountAmount", discountAmount);
    }
  }, [getRate, getDiscountPercent, getQuantity]);

  useEffect(() => {
    if (typeof serviceDiscountPer === "number") {
      totalAmount = parseFloat(serviceRate * serviceQuantity);
      let getDisPrice = totalAmount - serviceDiscountAmt;
      let totalValue = parseFloat(totalAmount) - parseFloat(getDisPrice);
      let discountInDecimal = totalValue / totalAmount;
      let discountInPercent = (discountInDecimal * 100).toFixed(1);
      setValue("discountPercent", parseFloat(discountInPercent));
    }
  }, [getDiscountAmount, getRate, getQuantity]);

  //API For Search Service
  const handleChange = (e) => {
    if (e.length > 0 && selectedPatient) {
      let finalSearchObj = {
        description: e,
        tariffId: tariffId,
        unitId: unitkey.unitId,
        groupId: 0,
        classId: selectedPatient.classId,
        companyId: selectedPatient.CompanyId,
        applicableTo: 1,
        isEmergency: false,
      };
      searchService(finalSearchObj)
        .then((response) => {
          //
          setServiceList(response.data.result);
          // setActions(response.data.actions);
        })
        .catch((response) => {});
    }
  };

  // API to Get Data Based on Selected Service
  const handleSelectedService = (data) => {
    // getSelectedServiceDetails(
    //   data.isPackaged,
    //   bedCategoryId,
    //   data.value,
    //   tariffId
    // )
    //   .then((response) => {
    //
    //     setIsDoctorShareApplicable(
    //       response.data.result[0].doctorShareApplicable
    //     );
    //     setIsDiscountApplicable(response.data.result[0].Concession);
    //     setValue("discountPercent", response.data.result[0].discountPercent);
    //   })
    //   .catch((res) => {
    //
    //   });
  };

  //API for Doctor List
  const handleDoctorList = (searchString) => {
    if (searchString.length > 0) {
      getDoctorList(searchString)
        .then((response) => {
          setDoctors(response.data.result);
        })
        .catch((res) => {});
    }
  };

  //API to Save Added Services
  const handleAddedService = () => {
    handleCloseSaveModal();
    setOpenBackdrop(true);
    // saveServices(
    //   savedServices,
    //   location?.state?.menuId ? location?.state?.menuId : props.menuId,
    //   privilege
    // )
    //   .then((response) => {
    //     if (response.status === 200) {
    //       setOpenSaveModal(false);
    //       successAlert(response.data.message);
    //       handlePatientInfo();
    //       setAddedSevices([]);
    //       setOpenBackdrop(false);

    //       setSavedSevices([]);
    //       setOpenBackdrop(false);
    //       setValue("serviceDate", new Date());
    //       setValue("serviceTime", new Date());
    //       setCheckDuplicate(false);
    //     } else {
    //       errorAlert(response.data.error);
    //       setOpenBackdrop(false);
    //     }
    //   })
    //   .catch((res) => {
    //     errorAlert(res.data.result);
    //     setOpenBackdrop(false);
    //   });
    saveAlterIPDCharges(finalAlterData)
      .then((response) => {
        successAlert(response?.data?.result);
        setOpenBackdrop(false);
        setPreviousCharges([]);
        setSelectedPatient(null);
        setFinalAlterData(null);
        setTotalPayable(0);
        setValue("ward", null);
        setValue("bedCategory", null);
        setValue("bedNo", null);
        setValue("ipdChargesSearch", null);
        setAdmissionId(null);
        setPatientId(null);
      })
      .catch((error) => {
        errorAlert(error?.message);
        setOpenBackdrop(false);
      });
  };

  //Edit Charge
  function editCharge(chargeDetails, index) {
    console.log(
      "editChargeeditChargeeditChargeeditCharge",
      chargeDetails,
      index
    );
    setSavedSevices([]);
    setPreviousChargesAction(previousChargesAction);
    let serviceObj;
    setDataId(index);
    let serviceData = chargeDetails["Service Description"];

    let substring = serviceData.split("|");
    serviceObj = {
      label: substring[1],
      // serviceName: substring[1],
      ServiceCode: substring[0],
      value: chargeDetails.serviceId,
      ServiceId: chargeDetails.serviceId,
      // discountApplicable: chargeDetails.discountApplicable,
    };
    if (chargeDetails.discountApplicable === false) {
      setIsDiscountApplicable(false);
    } else {
      setIsDiscountApplicable(true);
    }

    let myObj = {
      searchServiceList: serviceObj,
      qty: chargeDetails.Quantity,
      rate: chargeDetails.Rate,

      // discountPercent: chargeDetails["Discount Per"],
      // discountAmount: chargeDetails["Discount Amount"],
    };
    reset(myObj);
    setValue("discountAmount", chargeDetails["DiscountAmt"], {
      shouldValidate: true,
    });
    setValue("discountPercent", chargeDetails["DiscountPerc"], {
      shouldValidate: true,
    });
    setValue("doctor", {
      id: chargeDetails["Doctor Name"],
      value: chargeDetails["Doctor Name"],
      label: chargeDetails["Doctor Name"],
    });
  }

  //Delete Charge
  function deleteCharge(index, status, rowData) {
    setIndex(index);
    setStatus(status);
    setRowData(rowData);
    setOpenConfirmation(true);
  }
  const handleDeleteRecord = () => {
    let roleObj = JSON.parse(localStorage.getItem("userInfo"));
    if (status === true) {
      let finalDeleteObj = {
        discountAmount: rowData["Discount Amount"],
        discountPercent: rowData["Discount Per"],
        serviceListDto: [
          {
            billInfoId: rowData.billInfoId,
            discountAmount: rowData["Discount Amount"],
            discountPercent: rowData["Discount Per"],
            isCancelled: true,
            quantity: rowData["Quantity"],
            rate: rowData["Rate"],
            services: rowData.serviceId,
          },
        ],
        visitId: visitId,
        unitId: roleObj.units[0].id,
      };
      handlePrevDelete(finalDeleteObj);
    } else {
      addedServices.splice(index, 1);
      setAddedSevices([...addedServices]);
      savedServices.splice(index, 1);
      setSavedSevices([...savedServices]);
      setOpenConfirmation(false);
    }
  };
  const handlePrevDelete = (deleteData) => {
    // updateCharges(deleteData)
    //   .then((response) => {
    //
    //     if (response.status === 200) {
    //       successAlert(response.data.message);
    //       handlePatientInfo();
    //       setOpenConfirmation(false);
    //     }
    //   })
    //   .catch((res) => {
    //
    //     errorAlert(res.data.message);
    //   });
  };

  let serviceName,
    serviceCode,
    doctorName,
    doctorId,
    serviceId,
    discountApplicable;
  //Add Charges

  //   function onSubmit(data) {
  //     data.searchServiceList.serviceName !== null
  //       ? (serviceName = data.searchServiceList.label)
  //       : (serviceName = null);
  //     data.searchServiceList.ServiceCode !== null
  //       ? (serviceCode = data.searchServiceList.ServiceCode)
  //       : (serviceCode = null);
  //     data.searchServiceList.ServiceCode !== null
  //       ? (serviceId = data.searchServiceList.ServiceId)
  //       : (serviceId = null);
  //     discountApplicable = isDiscountApplicable;

  //     data.doctor && data.doctor !== null
  //       ? (doctorName = data.doctor.label)
  //       : (doctorName = null);
  //     data.doctor && data.doctor !== null
  //       ? (doctorId = data.doctor.id)
  //       : (doctorId = 0);

  //     let totalAmt = parseFloat(data.qty) * parseFloat(data.rate);

  //     let discountInPercent, discountAmountAvailable;

  //     // //if isDiscountApplicable Flag not given
  //     // discountInPercent = parseInt(data.discountPercent);
  //     // discountAmountAvailable = parseInt(data.discountAmount);

  //     let netAmt;
  //     let userInfo = JSON.parse(localStorage.getItem("userInfo"));
  //     console.log("data.discountPercent", data.discountPercent);

  //     if (isDiscountApplicable === true) {
  //       if (isNaN(data.discountPercent) || data.discountPercent === "NaN") {
  //         discountInPercent = 0;
  //       } else {
  //         discountInPercent = parseInt(data.discountPercent);
  //       }
  //       if (
  //         isNaN(parseInt(data.discountAmount)) ||
  //         data.discountAmount === "NaN"
  //       ) {
  //         discountAmountAvailable = 0;
  //       } else {
  //         discountAmountAvailable = parseInt(data.discountAmount);
  //       }
  //     } else {
  //       discountInPercent = 0;
  //       discountAmountAvailable = 0;
  //     }

  //     netAmt = totalAmt - discountAmountAvailable;

  //     if (previousChargesAction === true && dataId !== null) {
  //       let discountAmountValue, discountPercentValue;
  //       if (
  //         data.discountAmount === null ||
  //         data.discountAmount === "" ||
  //         data.discountAmount === "NaN" ||
  //         isNaN(data.discountAmount)
  //       ) {
  //         discountAmountValue = 0;
  //       } else {
  //         discountAmountValue = parseFloat(data.discountAmount);
  //       }
  //       if (
  //         data.discountPercent === null ||
  //         data.discountPercent === "" ||
  //         data.discountPercent === "NaN" ||
  //         isNaN(data.discountPercent)
  //       ) {
  //         discountPercentValue = 0;
  //       } else {
  //         discountPercentValue = parseFloat(data.discountPercent);
  //       }

  //       let updateObj = {
  //         discountAmount: parseFloat(discountAmountValue),
  //         discountPercent: parseFloat(discountPercentValue),
  //         serviceListDto: [
  //           {
  //             billInfoId: dataId,
  //             discountAmount: parseFloat(discountAmountValue),
  //             discountPercent: parseFloat(discountPercentValue),
  //             isCancelled: false,
  //             quantity: parseInt(data.qty),
  //             rate: parseFloat(data.rate),
  //             services: parseInt(serviceId),
  //           },
  //         ],
  //         unitId: userInfo.unitId,
  //         // visitId: visitId,
  //       };

  //       // updateCharges(updateObj)
  //       //   .then((response) => {
  //       //
  //       //     if (response.status === 200) {
  //       //       successAlert(response.data.message);
  //       //       handlePatientInfo();
  //       //       reset(defaultValues);
  //       //       setValue("discountAmount", 0);
  //       //     }
  //       //   })
  //       //   .catch((res) => {
  //       //
  //       //     errorAlert(res.data.message);
  //       //   });
  //     } else {
  //       //Object To Add Data to Table
  //       let finalObj = {
  //         "Service Description": serviceCode + " | " + serviceName,
  //         // "From Date": data.fromDate,
  //         // "To Date": data.toDate,
  //         Quantity: parseInt(data.qty),
  //         doctorId: doctorId,
  //         serviceId: parseInt(serviceId),
  //         Rate: parseFloat(data.rate),
  //         "Total Amt": totalAmt,
  //         "Discount Per": discountInPercent,
  //         "Discount Amount": discountAmountAvailable,
  //         "Net Amt": netAmt,
  //         "Doctor Name": doctorName,
  //         discountApplicable: discountApplicable,
  //       };
  //       let concessionValue;
  //       if (isDiscountApplicable === false) {
  //         concessionValue = 0;
  //       } else {
  //         concessionValue = 1;
  //       }

  //       if (dataId !== null) {
  //         addedServices[dataId] = finalObj;
  //         //Object Required to Save Added Services
  //         let userInfo = JSON.parse(localStorage.getItem("userInfo"));

  //         let savedService = {
  //           doctorId: doctorId,
  //           quantity: parseInt(data.qty),
  //           classId: 0,
  //           // services: serviceId,
  //           // discountAmount: discountAmountAvailable,
  //           // discountPercent: discountInPercent,
  //           rate: parseFloat(data.rate),
  //           // visitId: visitId,
  //           unitId: userInfo.unitId,
  //           //extra values
  //           addedBy: userInfo.userId,
  //           updatedBy: userInfo.userId,
  //           opd_Ipd_External: 1,
  //           opd_Ipd_External_Id: 0,
  //           tariffId: tariffId,
  //           serviceId: serviceId,
  //           totalAmount: totalAmt,
  //           netAmount: netAmt,
  //           concession: discountAmountAvailable,
  //           discount: discountAmountAvailable,
  //           staffFree: free,
  //           isPackageService: isPackage,
  //           emergency: isEmergency,
  //           opd_Ipd_External_Id: admissionId,
  //           hospShareAmount: parseFloat(data.rate),
  //           doctorShareAmount: 0,
  //           chargeIdPackage: 0,
  //           sponsorType: true,
  //           classId: classId,
  //           companyId: companyId,
  //           fromDate: data.fromDate,
  //           toDate: data.toDate,
  //           byDate: false,
  //           groupId: groupId,
  //         };
  //         savedServices[dataId] = savedService;
  //       } else {
  //         let obj = addedServices.find(
  //           (o) => o["Service Description"] === serviceCode + " | " + serviceName
  //         );
  //         if (typeof obj === "undefined") {
  //           addedServices.push(finalObj);
  //           //Object Required to Save Added Services
  //           let userInfo = JSON.parse(localStorage.getItem("userInfo"));

  //           let savedService = {
  //             doctorId: doctorId,
  //             quantity: parseInt(data.qty),
  //             classId: 0,
  //             // services: serviceId,
  //             // discountAmount: discountAmountAvailable,
  //             // discountPercent: discountInPercent,
  //             rate: parseFloat(data.rate),
  //             // visitId: visitId,
  //             unitId: userInfo.unitId,
  //             //extra values
  //             addedBy: userInfo.userId,
  //             updatedBy: userInfo.userId,
  //             opd_Ipd_External: 1,
  //             opd_Ipd_External_Id: 0,
  //             tariffId: tariffId,
  //             serviceId: serviceId,
  //             totalAmount: totalAmt,
  //             netAmount: netAmt,
  //             concession: discountAmountAvailable,
  //             discount: discountAmountAvailable,
  //             staffFree: free,
  //             isPackageService: isPackage,
  //             emergency: isEmergency,
  //             opd_Ipd_External_Id: admissionId,
  //             hospShareAmount: 0,
  //             doctorShareAmount: 0,
  //             chargeIdPackage: 0,
  //             sponsorType: true,
  //             classId: classId,
  //             companyId: companyId,
  //             fromDate: data.fromDate,
  //             toDate: data.toDate,
  //             byDate: false,
  //             groupId: groupId,
  //           };
  //           savedServices.push(savedService);
  //           setCheckDuplicate(false);
  //         } else {
  //           setCheckDuplicate(true);
  //         }
  //       }
  //     }

  //     setDataId(null);
  //     reset(defaultValues);
  //     setValue("fromDate", data.fromDate);
  //     setValue("toDate", data.toDate);
  //   }

  const onSubmit = (data) => {
    console.log("datadatadata321", data);
    let postObject = {
      ChargeId: null,
      Date: format(data?.serviceDate, "dd-MM-yyyy"),
      Time: format(data?.serviceTime, "hh:mm aa"),
      ServiceCode: data?.searchServiceList?.ServiceCode
        ? data?.searchServiceList?.ServiceCode
        : null,
      Description: data?.searchServiceList?.label,
      Rate: Number(data?.rate),
      Quantity: Number(data?.qty),
      TotalAmount: Number(data?.rate) * Number(data?.qty),
      NetAmount:
        Number(Number(data?.rate) * Number(data?.qty)) -
        Number(data?.discountAmount),
      Opd_Ipd_External_Id: null,
      LoginName: unitkey?.loginName,
      Doctor: data?.doctor?.label,
      OTSheetNo: "",
      Concession: 0,
      Discount: 0,
      StaffFree: 0,
      DoctorId: 0,
      RateEditable: false,
      IsPackage: false,
      SponsorType: false,
      ServiceId: data?.searchServiceList?.ServiceId
        ? data?.searchServiceList?.ServiceId
        : null,
      DiscountPerc: Number(data?.discountPercent),
      DiscountAmt: Number(data?.discountAmount),
      DeductionPerc: 0,
      DeductionAmt: 0,
      deductible: 0,
      NetAmt:
        Number(Number(data?.rate) * Number(data?.qty)) -
        Number(data?.discountAmount),
      AdminCharges: true,
      IsServiceTaxApp: true,
      IsGSTApplicable: false,
      GSTAmountLimit: 0,
      GSTAmount: 0,
      GSTApplicableAmount: 0,
      IsCancelled: false,
    };
    setPreviousCharges((prevData) => [...prevData, { ...postObject }]);
    reset(defaultValues);
  };

  const onSaveAlterIpdCharges = (privilege) => {
    let ipdBillSaveObj = {
      tariffId: selectedPatient && selectedPatient.TariffId,
      patientId: selectedPatient && selectedPatient?.PatientId,
      wardId: selectedPatient && selectedPatient?.wardId,
      bedId: selectedPatient && selectedPatient?.BedId,
      bedCategoryId: selectedPatient && selectedPatient?.bedCategoryId,
      patientSourceId: selectedPatient && selectedPatient.PatientSourceId,
      patientCategoryId: selectedPatient && selectedPatient.PatientCategoryId,
      unitId: selectedPatient && selectedPatient?.unitId,
      companyId: selectedPatient && selectedPatient.CompanyId,
      compRefNo: "",
      campID: 0,
      billNo: "",
      interOrFinal: false,
      creditAmount: 0,
      totalConcessionAmount: 0,
      isFree: false,
      concessionAuthorisedBy: 0,
      isSettled: selectedPatient && selectedPatient.isBilled,
      computerName: "",
      sponsorType: false,
      seniorCitizenCon: false,
      isCash: false,
      consumeAdvance: 0,
      isAdvanceConsume: false,
      chargesRequestDto: previousCharges?.map((val) => ({
        date: new Date(val?.Date),
        time: new Date(val?.Time),
        fromDate: "",
        toDate: "",
        Opd_Ipd_External_Id: val?.Opd_Ipd_External_Id,
        Opd_Ipd_External: 0,
        chargeApplicableTo: "",
        TariffServiceId: 0,
        ServiceId: val?.ServiceId,
        Description: val?.Description,
        DoctorId: val?.DoctorId,
        Rate: val?.Rate,
        Quantity: val?.Quantity,
        TotalAmount: val?.TotalAmount,
        Concession: val?.Concession,
        Discount: val?.Discount,
        StaffFree: 0,
        NetAmount: 0,
        HospShareAmount: 0,
        DoctorShareAmount: 0,
        isPackageService: val?.IsPackage,
        ChargeIdPackage: 0,
        Emergency: false,
        SponsorType: false,
        AddedBy: unitkey.userId,
        UpdatedBy: unitkey.userId,
        chargeId: val?.ChargeId,
        originalChargeId: 0,
        isCancelled: val?.IsCancelled === false ? 0 : 1,
        groupId: 0,
        tariffId: selectedPatient.TariffId,
        companyId: selectedPatient.CompanyId,
        classId: 0,
        procedureServiceId: 0,
        isGenerated: false,
        isPackaged: false,
        isBilled: selectedPatient.isBilled,
      })),
      // addedBy: unitkey.userId,
      // opdIpd: 1,
      // cashCounterId: unitkey.cashCounterId,
      // paymentInfoList: requiredInfoList,
      // consumeAdvance: 0,
      // totalAmount: totalPayable,
      // billAmount: 0,
      // menuId: location?.state?.menuId,
      // privilege: privilege,
      // visitId: selectedPatient && selectedPatient.AdmissionId,
      // concessionAuthorisedBy: 0,
      // patientAdvanceId: 0,
      // patientAdvanceUsed: selectedPatient?.PatientAdvanceAmount
      //   ? selectedPatient?.PatientAdvanceAmount
      //   : 0,
    };
    console.log("ipdBillSaveObj", ipdBillSaveObj);
    setFinalAlterData(ipdBillSaveObj);
    setOpenSaveModal(true);
  };

  //Function to get Applied Discount Value
  function appliedDiscount(discountData) {
    // handleDiscount(discountData);
    reset1();
  }

  const handlePreviousListChange = (e) => {
    let searchedService = previousChargesList.filter((name) =>
      name["Description"].match(new RegExp(e, "i"))
    );
    let searchedServiceData = [];
    searchedService.map((row, index) => {
      let dropdownObject = {
        label: row["Description"],
        value: index,
      };
      searchedServiceData.push(dropdownObject);
    });
    setPreviousChargesDropdown(searchedServiceData);
  };

  const handleSearchedPreviousList = (searchKey) => {
    let searchedServiceList = previousCharges.filter((name) =>
      name["Description"].match(new RegExp(searchKey, "i"))
    );

    setPreviousCharges(searchedServiceList);
  };

  //Convert to Charge
  const handleConvertToCharge = () => {
    let selectBillInfoId = [];
    selected.map((item) => {
      selectBillInfoId.push(item.ChargeId);
    });

    let finalObj = {
      admissionId: admissionId,
      charges: selectBillInfoId,
      packageId: null,
      pkgChargeId: null,
      menuId:
        props?.from === "Billing" ? props.menuId : location?.state?.menuId,
      privilege: privilege,
      tariffId: selectedPatient?.TariffId,
    };

    if (selectBillInfoId.length > 0) {
      convertToPackage(finalObj)
        .then((response) => {
          if (response.status === 200) {
            successAlert(response.data.message);
            handlePatientInfo();
          }
        })
        .catch((res) => {
          errorAlert(res.data.message);
        });
    }
  };

  //Delete Service
  const handleDeleteService = () => {
    setOpenBackdrop(true);

    let deletedServiceId = [];
    selected.map((item) => {
      deletedServiceId.push(item.ChargeId);
    });

    let deleteObj = {
      admissionId: admissionId,
      chargeId: deletedServiceId,
      tariffId: tariffId,
      menuId: props.menuId ? props.menuId : location?.state?.menuId,
      privilege: privilege,
    };

    deleteService(deleteObj)
      .then((response) => {
        setOpenModal(false);
        if (response.data.statusCode === 200) {
          setOpenBackdrop(false);
          deleteAlert(response.data.message);
          handlePatientInfo();
          setSelected([]);
        }
      })
      .catch((res) => {
        setOpenBackdrop(false);
      });
  };

  const handleCloseSaveModal = () => {
    setOpenSaveModal(false);
    setOpenBackdrop(false);
  };

  useEffect(() => {
    if (props["from"]) {
      if (props.from === "Billing") {
        fetchUserActionsByMenuId(props.menuId)
          .then((response) => response.data)
          .then((res) => {
            setUserActions(res.result);
          });
        setAdmissionId(props.admissionId);
        setPatientId(props.patientId);
      }
    } else {
      location?.state?.menuId &&
        fetchUserActionsByMenuId(location?.state?.menuId)
          .then((response) => response.data)
          .then((res) => {
            setUserActions(res.result);
          });

      if (location?.state?.billParams) {
        setAdmissionId(location?.state?.billParams?.admissionId);
        setPatientId(location?.state?.billParams?.patientId);
      }
    }

    fetchBedCategory()
      .then((response) => response.data)
      .then((res) => {
        setBedCategoryOptions(res.result);
      });
  }, []);

  console.log("selectedPatient123", selectedPatient);
  console.log("previousCharges", previousCharges);

  return (
    <>
      <div className="pt-20 ml-2">
        <div className="grid">
          <div className="text-center text-black font-bold text-xl mr-8 my-auto">
            Alter IPD Charges
          </div>
          {(props.admissionId && props.patientId) ||
          (location.state && location.state) === null ? null : (
            <div className="w-96">
              <SearchDropdown
                control={control}
                placeholder="Search By Patient Name/MR No./Mobile No."
                dataArray={patientList}
                name="ipdChargesSearch"
                searchIcon={true}
                isClearable={true}
                handleInputChange={handlePatientSearch}
                inputRef={{
                  ...register("ipdChargesSearch", {
                    onChange: (e) => {
                      if (e.target.value !== null) {
                        setAdmissionId(e.target.value.id);
                        setPatientId(e.target.value.PatientId);
                      } else {
                        setAdmissionId(null);
                        setPatientId(null);
                        setSelectedPatient(null);
                      }
                    },
                  }),
                }}
              />
            </div>
          )}
        </div>

        <div className="w-full  mt-2 md:rounded-md">
          {/* //Patient Info// */}
          <div className="">
            {admissionId !== null ? (
              <fieldset
                className="border border-gray-300 col-span-3 w-full lg:py-0
               text-left lg:px-2 md:p-2 rounded bg-gray-100"
              >
                <div className=" grid  lg:grid-cols-4 2xl:grid-cols-4 gap-y-1 gap-x-2 px-3 ">
                  <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-2 font-semibold text-sm py-1">
                    <span className=" font-semibold w-28">Patient Name</span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      <span className="text-gray-700 font-normal">
                        {selectedPatient && selectedPatient.patientName}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1 font-semibold text-sm py-1">
                    <span className=" font-semibold w-28">MR No.</span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      <span className="text-gray-700 font-normal">
                        {selectedPatient && selectedPatient.mrNo}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1 font-semibold text-sm py-1">
                    <span className=" font-semibold w-28">ADM Date</span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      <span className="text-gray-700 font-normal">
                        {selectedPatient && selectedPatient.admissionDate}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1 font-semibold text-sm py-1">
                    <span className=" font-semibold w-28">IPD No.</span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      <span className="text-gray-700 font-normal">
                        {selectedPatient && selectedPatient.IpdNo}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1 font-semibold text-sm py-1">
                    <span className=" font-semibold w-28">Gender</span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      <span className="text-gray-700 font-normal">
                        {selectedPatient && selectedPatient.gender}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1 font-semibold text-sm py-1">
                    <span className=" font-semibold w-28">Age</span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      <span className="text-gray-700 font-normal">
                        {selectedPatient && selectedPatient.AgeYear}
                      </span>
                    </div>
                  </div>
                  {/* <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1 font-semibold text-sm py-1">
                  <span className=" font-semibold w-28">Department</span>
                  <div className="flex space-x-2 items-center">
                    <span>:</span>
                    <span className="text-gray-700 font-normal">
                      {selectedPatient && selectedPatient.department}
                    </span>
                  </div>
                </div> */}
                  <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1 font-semibold text-sm py-1">
                    <span className=" font-semibold w-28">Doctor</span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      <span className="text-gray-700 font-normal">
                        {selectedPatient && selectedPatient.doctor}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1 font-semibold text-sm py-1">
                    <span className=" font-semibold w-28">Ward</span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      {/* <span className="text-gray-700 font-normal">
                        {selectedPatient && selectedPatient.Ward}
                      </span> */}
                      <div className="w-60">
                        <DropdownField
                          control={control}
                          name="ward"
                          placeholder="Ward"
                          dataArray={wardOptions}
                          isSearchable={true}
                        />
                      </div>
                    </div>
                  </div>
                  {/* <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1 font-semibold text-sm py-1">
                  <span className=" font-semibold w-28">Room No.</span>
                  <div className="flex space-x-2 items-center">
                    <span>:</span>
                    <span className="text-gray-700 font-normal">
                      {selectedPatient && selectedPatient.roomNumber}
                    </span>
                  </div>
                </div> */}
                  <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1 font-semibold text-sm py-1">
                    <span className=" font-semibold w-28">Bed Category</span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      {/* <span className="text-gray-700 font-normal">
                        {selectedPatient && selectedPatient.BedCategory}
                      </span> */}
                      <div className="w-60">
                        <DropdownField
                          control={control}
                          name="bedCategory"
                          placeholder="Bed Category"
                          dataArray={bedCategoryOptions}
                          isSearchable={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1 font-semibold text-sm py-1">
                    <span className=" font-semibold w-28">Bed No.</span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      {/* <span className="text-gray-700 font-normal">
                        {selectedPatient && selectedPatient.BedNo}
                      </span> */}
                      <div className="w-60">
                        <DropdownField
                          control={control}
                          name="bedNo"
                          placeholder="Bed No"
                          dataArray={bedNoOptions}
                          isSearchable={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1 font-semibold text-sm py-1">
                    <span className=" font-semibold w-28">
                      Patient Category
                    </span>
                    <div className="flex space-x-2 items-center">
                      <span>:</span>
                      <span className="text-gray-700 font-normal">
                        {selectedPatient && selectedPatient.PatientCategory}
                      </span>
                    </div>
                  </div>
                  {selectedPatient?.CompanyName !== null &&
                    selectedPatient?.CompanyName !== "" && (
                      <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1 font-semibold text-sm py-1">
                        <span className=" font-semibold w-28">
                          Company Name
                        </span>
                        <div className="flex space-x-2 items-center">
                          <span>:</span>
                          <span className="text-gray-700 font-normal">
                            {selectedPatient && selectedPatient.CompanyName}
                          </span>
                        </div>
                      </div>
                    )}
                  {selectedPatient?.AssistentCompany !== null &&
                    selectedPatient?.AssistentCompany !== "" && (
                      <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1 font-semibold text-sm py-1">
                        <span className=" font-semibold w-32">
                          Assistant Company
                        </span>
                        <div className="flex space-x-2 items-center">
                          <span>:</span>
                          <span className="text-gray-700 font-normal">
                            {selectedPatient &&
                              selectedPatient.AssistentCompany}
                          </span>
                        </div>
                      </div>
                    )}
                </div>
              </fieldset>
            ) : (
              ""
            )}
          </div>

          {/* //Previous Charges// */}
          {admissionId !== null ? (
            <div className="border rounded-md w-full overflow-hidden mt-2 px-5 bg-white">
              <div className="text-sm font-semibold text-black  mb-3">
                Prev Charges
              </div>
              <div className="grid grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-x-2">
                <div className="">
                  <SearchDropdown
                    name="searchlistofcharges"
                    control={control}
                    searchIcon={true}
                    isSearchable={true}
                    isClearable={true}
                    dataArray={previousChargesDropdown}
                    handleInputChange={handlePreviousListChange}
                    placeholder="Search Services"
                    inputRef={{
                      ...register("searchlistofcharges", {
                        onChange: (e) => {
                          if (e.target.value !== null) {
                            setSearchedPreviousCharges(true);
                            handleSearchedPreviousList(e.target.value.label);
                            // setPreviousCharges(searchedService)
                          } else {
                            setSearchedPreviousCharges(false);
                            setPreviousCharges(previousChargesList);
                          }
                        },
                      }),
                    }}
                  />
                </div>
                <div className="text-sm flex space-x-2 justify-between lg:col-span-2 2xl:col-span-3">
                  <div>
                    <FormControl className="whitespace-nowrap">
                      <RadioGroup
                        row
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={category}
                        onChange={(e) => {
                          setCategory(e.target.value);
                          setSelected([]);
                        }}
                      >
                        <FormControlLabel
                          value="All"
                          control={<Radio size="small" />}
                          label={
                            <Typography variant="body2">All Charges</Typography>
                          }
                        />
                        <FormControlLabel
                          value="Package"
                          control={<Radio size="small" />}
                          label={
                            <Typography variant="body2">Package</Typography>
                          }
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  <div className="flex justify-end">
                    {userActions.map((obj) => (
                      <>
                        {!obj.isAction && (
                          <>
                            {obj.action === "Create" && (
                              <>
                                <CommonButton
                                  className=" bg-green-600 text-white"
                                  onClick={() => {
                                    setPrivilege(obj.action);
                                    onSaveAlterIpdCharges(obj.action);
                                  }}
                                  label="Save"
                                />
                              </>
                            )}
                          </>
                        )}
                      </>
                    ))}
                  </div>
                </div>
              </div>
              {/* //Previous Visits Table// */}
              <div className="">
                <div className="grid grid-cols-5 gap-2 items-center">
                  {previousCharges.length > 0 ? (
                    <div className={style}>
                      <AlterIPDChargesTable
                        data={previousCharges}
                        setData={setPreviousCharges}
                        charges={category}
                        editCharge={editCharge}
                        deleteCharge={deleteCharge}
                        setPreviousChargesAction={setPreviousChargesAction}
                        setSelected={setSelected}
                        selected={selected}
                        setCheckIsPackage={setCheckIsPackage}
                        tariffId={tariffId}
                        selectedPatient={selectedPatient}
                      />
                    </div>
                  ) : (
                    <div className="my-8 w-full col-span-5">
                      <p className="w-full text-center">No Records Found</p>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex space-x-5 my-2">
                <div className="flex items-center ">
                  <label className="font-semibold text-sm mr-2">
                    Bill Amount :
                  </label>
                  <label>₹ {totalPayable}</label>
                </div>
                <div
                  className={`${
                    remainingAmount < 0
                      ? "text-customRed"
                      : remainingAmount > 0
                      ? "text-customBlue"
                      : "text-customOrange"
                  } flex items-center`}
                >
                  <label className="font-semibold text-sm mr-2">
                    Amount&nbsp;
                    {remainingAmount < 0
                      ? "Short "
                      : remainingAmount > 0
                      ? "Exceed "
                      : ""}
                    :
                  </label>
                  <label>
                    ₹ {remainingAmount > 0 && "+"}
                    {remainingAmount}
                  </label>
                </div>

                {/* //Apply Total Discount Form// */}
                {category.toLowerCase() === "patient" ? (
                  <div className="ml-10">
                    <form onSubmit={handleSubmit1(appliedDiscount)}>
                      <div className="flex space-x-2">
                        <div className="w-28">
                          <InputField
                            name="appliedDiscountPercent"
                            variant="outlined"
                            label="Dis %"
                            // error={errors1.appliedDiscountPercent}
                            control={control1}
                          />
                        </div>
                        <div className="w-28">
                          <InputField
                            name="appliedDiscountAmount"
                            variant="outlined"
                            label="Dis Amt"
                            // error={errors1.appliedDiscountAmount}
                            control={control1}
                          />
                        </div>
                        <button className="h-10 px-3  bg-customBlue  text-white rounded text-sm font-medium">
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            ""
          )}

          {/* //Add Charges// */}
          {userActions.map((obj) => (
            <>
              {!obj.isAction && obj.action === "Create" && (
                <>
                  {admissionId !== null &&
                  selectedPatient &&
                  // selectedPatient.Discharged === false &&
                  selectedPatient.isBilled === false ? (
                    <div className="border rounded-md w-full mt-2 px-5 mb-10 bg-white py-4 overflow-visible">
                      <form
                        onSubmit={handleSubmit(onSubmit)}
                        className="space-y-3"
                      >
                        <label className="font-semibold">Add Charges</label>
                        <div className="grid grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 2xl:grid-cols-10 gap-3">
                          <div className="col-span-2">
                            <CreateableSelect
                              name="searchServiceList"
                              control={control}
                              searchIcon={true}
                              isSearchable={true}
                              isClearable={true}
                              placeholder="Search Services *"
                              error={errors.searchServiceList}
                              dataArray={serviceList}
                              onInputChange={handleChange}
                              inputRef={{
                                ...register("searchServiceList", {
                                  onChange: (e) => {
                                    if (e.target.value !== null) {
                                      handleSelectedService(e.target.value);
                                      setValue("rate", e.target.value.Rate, {
                                        shouldValidate: true,
                                      });
                                      setValue("qty", 1, {
                                        shouldValidate: true,
                                      });
                                      setClassId(e.target.value.ClassId);
                                      setGroupId(e.target.value.GroupId);
                                      setCompanyId(e.target.value.CompId);
                                      setIsDoctorShareApplicable(
                                        e.target.value.DoctorShare
                                      );
                                      setIsDiscountApplicable(
                                        e.target.value.Concession
                                      );
                                      if (e.target.value.Free === false) {
                                        setFree(0);
                                      } else {
                                        setFree(1);
                                      }
                                      // setIsPackage(e.target.value.Healthplan_Package);
                                      setIsPackage(e.target.value.IsPackage);
                                      setIsEmergency(e.target.value.Emergency);
                                    } else {
                                      setValue("rate", 0, {
                                        shouldValidate: true,
                                      });
                                      setValue("qty", 0);
                                      setValue("doctor", null);
                                    }
                                  },
                                }),
                              }}
                            />
                          </div>
                          <div className="">
                            <InputField
                              name="qty"
                              variant="outlined"
                              label="Qty *"
                              error={errors.qty}
                              control={control}
                            />
                          </div>
                          <div className="">
                            <InputField
                              name="rate"
                              variant="outlined"
                              label="Rate*"
                              error={errors.rate}
                              control={control}
                            />
                          </div>
                          {isDiscountApplicable === true && (
                            <div className="">
                              <InputField
                                type="number"
                                name="discountPercent"
                                variant="outlined"
                                label="Dis %"
                                error={errors.discountPercent}
                                control={control}
                              />
                            </div>
                          )}
                          {isDiscountApplicable === true && (
                            <div className="">
                              <InputField
                                type="number"
                                name="discountAmount"
                                variant="outlined"
                                label="Dis Amt"
                                error={errors.discountAmount}
                                control={control}
                              />
                            </div>
                          )}
                          {isDoctorShareApplicable === true && (
                            <div className="col-span-2">
                              <SearchDropdown
                                name="doctor"
                                control={control}
                                placeholder="Doctor *"
                                dataArray={doctors}
                                error={errors.doctor}
                                handleInputChange={handleDoctorList}
                                isSearchable={true}
                                isClearable={true}
                              />
                            </div>
                          )}
                          <div>
                            <DatePickerFieldNew
                              control={control}
                              name="serviceDate"
                              label="Date"
                              inputFormat="dd-MM-yyyy"
                            />
                          </div>
                          <div>
                            <TimePickerFieldNew
                              control={control}
                              name="serviceTime"
                              label="Time"
                              inputFormat="hh:mm"
                            />
                          </div>
                          <div className="w-full flex">
                            {dataId !== null ? (
                              <div className=" flex space-x-2">
                                <CommonButton
                                  label="Update"
                                  type={"submit"}
                                  className="bg-customGreen text-white"
                                />
                                <CommonButton
                                  label="Cancel"
                                  className="border border-customRed text-customRed"
                                  onClick={() => {
                                    reset(defaultValues);
                                    setValue("discountAmount", 0);
                                    setPreviousChargesAction(false);
                                    setDataId(null);
                                  }}
                                />
                              </div>
                            ) : (
                              <CommonButton
                                type={"submit"}
                                label="Add"
                                className="bg-green-600 text-white"
                                onClick={() => {
                                  setPreviousChargesAction(false);
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </form>
                      {/* <div>
                        {checkDuplicate === true ? (
                          <p className="text-sm text-red-500">
                            Record Already Present
                          </p>
                        ) : (
                          ""
                        )}
                      </div> */}

                      {/* {addedServices && addedServices.length > 0 ? (
                        <div className="">
                          <AddedServiceTable
                            data={addedServices}
                            actions={actions}
                            editCharge={editCharge}
                            deleteCharge={deleteCharge}
                          />
                        </div>
                      ) : (
                        ""
                      )} */}
                    </div>
                  ) : (
                    ""
                  )}
                </>
              )}
            </>
          ))}
        </div>
      </div>
      <CommonBackDrop openBackdrop={openBackdrop} />
      {/* //Convert To Charge// */}
      <Modal
        open={openCovertToCharge}
        // onClose={() => {
        //   setOpenCovertToCharge(false);
        // }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
          }}
        >
          <ConvertToCharge
            setOpenCovertToCharge={setOpenCovertToCharge}
            menuId={location?.state?.menuId}
            privilege={privilege}
          />
        </Box>
      </Modal>
      {/* //Delete Confirmation Modal// */}
      <Modal
        open={openConfirmation}
        onClose={() => {
          setOpenConfirmation(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "2px solid #848211",
            borderRadius: "0.5rem",
            boxShadow: 24,
            p: 4,
            width: "46%",
            height: "auto",
          }}
        >
          <p className="my-3 tracking-wide font-bold text-lg text-center ">
            Please Confirm to Delete Record
          </p>

          <div className="flex justify-center space-x-3">
            <button
              className="h-9 px-3 border border-red-700 text-red-700 rounded text-base font-medium"
              onClick={() => {
                setOpenConfirmation(false);
              }}
            >
              Cancel
            </button>
            <button
              className="h-9 px-3  bg-customGreen text-white rounded text-base font-medium"
              onClick={() => handleDeleteRecord()}
            >
              Confirm
            </button>
          </div>
        </Box>
      </Modal>

      {/* //Confirmation to Delete Previous Services */}
      <ConfirmationModal
        confirmationOpen={openModal}
        confirmationHandleClose={() => setOpenModal(false)}
        confirmationSubmitFunc={() => handleDeleteService()}
        confirmationLabel="Confirmation "
        confirmationMsg="Are You Sure ?"
        confirmationButtonMsg="Proceed"
      />
      {/* //Confirmation to Save Added Services */}
      <ConfirmationModal
        confirmationOpen={openSaveModal}
        confirmationHandleClose={() => handleCloseSaveModal()}
        confirmationSubmitFunc={() => handleAddedService()}
        confirmationLabel="Confirmation "
        confirmationMsg="Are You Sure ?"
        confirmationButtonMsg="Proceed"
      />
    </>
  );
}

// {
//     "ChargeId": 11300028,
//     "Date": "15-11-2025",
//     "Time": "02:23 PM",
//     "ServiceCode": "002",
//     "Description": "Activated Clotting Time (ACT)",
//     "Rate": 330,
//     "Quantity": 1,
//     "TotalAmount": 330,
//     "NetAmount": 330,
//     "Opd_Ipd_External_Id": 1071202,
//     "LoginName": "67",
//     "Doctor": null,
//     "OTSheetNo": "",
//     "Concession": 0,
//     "Discount": 0,
//     "StaffFree": 0,
//     "DoctorId": 0,
//     "RateEditable": false,
//     "IsPackage": false,
//     "SponsorType": false,
//     "ServiceId": 2,
//     "DiscountPerc": 0,
//     "DiscountAmt": 0,
//     "DeductionPerc": 0,
//     "DeductionAmt": 0,
//     "deductible": 0,
//     "NetAmt": 330,
//     "AdminCharges": true,
//     "IsServiceTaxApp": true,
//     "IsGSTApplicable": false,
//     "GSTAmountLimit": 0,
//     "GSTAmount": 0,
//     "GSTApplicableAmount": 0,
//     "IsCancelled": false
// }

//  private Long tariffId;
//     private Long menuId;
//     private Long patientId;

//     private Long wardId;
//     private Long bedId;
//     private Long bedCategoryId;

//     private Long patientSourceId;
//     private Long patientCategoryId;

//     private Long unitId;

//     private Long companyId=0l;

//     private String compRefNo="";

//     private Long campID=0l;

//     private String billNo;

//     private Boolean interOrFinal=false;

//     private Double creditAmount=0.0;

//     private Double totalConcessionAmount=0.0;

//     private Boolean isFree=false;

//     private Long concessionAuthorisedBy=0l;

//     private Boolean isSettled=false;

//     private String computerName;
//     private Boolean sponsorType=false;
//     private Boolean seniorCitizenCon=false;

//     private Boolean isCash=false;

//     private Double consumeAdvance=0.0;

//     private Boolean isAdvanceConsume=false;
